module.exports = __webpack_public_path__ + "static/media/PaperPlane.8a8d02bd.svg";